




































import Vue from "vue";

// Vue components
import LocaleDateTimeTooltip from "@/components/LocaleDateTimeTooltip.vue";
import ServiceCountersTableCard from "./ServiceCountersTableCard.vue";

// Model
import { MachineStatus } from "@/model/data/status/MachineStatus";
import { MaintenanceStatusEnum, MaintenanceStatusEnumToLabel, GetMachineMaintenanceStatusIconColor } from "@/model/data/status/MaintenanceStatusEnum";

export default Vue.extend({
    components: {
        LocaleDateTimeTooltip,
        ServiceCountersTableCard,
    },
    data() {
        return {
            MaintenanceStatusEnum,
            dialog: false,
        };
    },
    props: {
        machine: { type: Object as () => MachineStatus, required: true },
    },
    methods: {
        MaintenanceStatusEnumToLabel,
        getIconColor(status: MaintenanceStatusEnum) {
            return GetMachineMaintenanceStatusIconColor(status);
        },

        onOpenMaintenanceDetails() {
            this.dialog = true;
        },
    },
});
